// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__wA3u-","empty":"ModalGraph_empty__1Cr-t"};